<template>
  <template v-for="facet in filteredFacets">
    <div class="flex flex-col items-center w-full py-2 border-b border-gray-300">
      <panel-container
        :id="facet.paramName"
        :title="facet.title"
        main-panel-class="w-full"
        :panel-button-text-classes="['font-light normal-case']"
        heading-class="w-full py-3 text-sm items-center"
      >
        <component
          :is="registeredComponents[facet.component]"
          :filterAttribute="facet.attribute"
          :searchable="facet.searchable ?? false"
        />
        <template #title>
          <current-refinement-count :attribute="facet.attribute" />
        </template>
      </panel-container>
    </div>
  </template>
</template>
<script setup>
import { computed } from "vue";
import PanelContainer from "@/components/ExperiencePage/Algolia/AlgoliaPanelContainer.vue";
import { hasAcceptanceStatusFilterEnabled } from "@/composables/authorization.js";
import { useRegisteredFacets } from "./composables/useRegisteredFacets";
import CurrentRefinementCount from "./Display/CurrentRefinementCount.vue";
import CheckboxFilter from "./Filters/CheckboxFilter.vue";

const { currentFacets } = useRegisteredFacets();

const registeredComponents = {
  CheckboxFilter,
};

const filteredFacets = computed(() => {
  if (hasAcceptanceStatusFilterEnabled.value) {
    return currentFacets.value;
  }
  return currentFacets.value.filter((facet) => facet.paramName !== "acceptance_status");
});
</script>
